import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import _ from "lodash";
import { useForm } from "react-hook-form";
import PatientAutocomplete from "../utils/patient/search/Autocomplete";

const defaultPatient = { id: "", surname: "" };
const PatientsSearchBar = () => {
  const navigate = useNavigate();
  const form = useForm({ defaultValues: defaultPatient });
  const patientId = form.watch("id");

  useEffect(() => {
    if (_.isNumber(patientId)) {
      const patient = form.getValues();
      navigate(`/patients/${patientId}`, {
        state: { patient, path: "/" },
      });
    }
  }, [patientId]);

  return (
    <PatientAutocomplete
      form={form}
      helperText=""
      label={"Buscar pacientes.."}
      noRequired={true}
    />
  );
};

export default PatientsSearchBar;
